import EditNotificationGroupsTemplate from './editNotificationGroups.html';
import EditNotificationGroupDataProviderModule from './editNotificationGroupsDataProvider';
import UsersTabModule from './tabs/users/users';
import SettingsTabModule from './tabs/settings/settings';

function EditNotificationGroupsRouter($stateProvider) {
  $stateProvider
    .state('main.notifications.groups.edit', {
      url: '/edit/:groupId?from&fromTab&tab',
      template: EditNotificationGroupsTemplate,
      controller: EditNotificationGroupsController,
      params: {
        from: null,
        fromTab: null,
        tab: null,
      }
    });
}

function EditNotificationGroupsController(
  $scope,
  $rootScope,
  $q,
  $filter,
  $state,
  EditNotificationGroupDataProvider,
  EditOrganizationDataProvider,
  utils,
  ToastsService
) {
  const $t = $filter('translate');

  // NOTE: Dirty hack for fast injecting ready-to-use data provider to child components
  EditNotificationGroupDataProvider.instance = new EditNotificationGroupDataProvider();
  const dataProvider = EditNotificationGroupDataProvider.instance;
  $scope.dataProvider = dataProvider;

  // Bridge it to our provider (which implements search in users tab)
  const previousOrgInstance = EditOrganizationDataProvider.instance;
  EditOrganizationDataProvider.instance = dataProvider;

  // #region Navigation Tabs
  $scope.tabs = [
    {
      id: 'users',
      name: $t('notifications.edit.tabs.users'),
      icon: 'far fa-users'
    },
    {
      id: 'settings',
      name: $t('notifications.edit.tabs.settings'),
      icon: 'far fa-bell'
    },
  ];
  // #endregion

  angular.extend($scope, {
    copyToClipboard: $rootScope.copyToClipboard,
  });

  init();

  function init() {
    $scope.loading = true;

    $q.all([
      dataProvider.currentOrganizationResource.init(),
      dataProvider.selectedGroupResource.init(),
    ])
      .then(() => {
        // Restore the active tab from the URL (so a reload stays on the same tab),
        // defaulting to 'users'.
        const validTabs = $scope.tabs.map(tab => tab.id);
        const urlTab = $state.params.tab;
        dataProvider.activeTab = validTabs.indexOf(urlTab) !== -1 ? urlTab : 'users';
        $scope.loading = false;
      }, (err) => {
        $scope.loading = false;
        if (err) {
          utils.handleApiError(err);
        }
        dataProvider.goBack();
      });

    // Keep the URL `tab` param in sync with the active tab (without reloading the view).
    $scope.$watch(() => dataProvider.activeTab, (tab) => {
      if (tab && tab !== $state.params.tab) {
        $state.go($state.current.name, { tab: tab }, { notify: false });
      }
    });

    $scope.$on('$destroy', () => {
      dataProvider.destroy();
      EditNotificationGroupDataProvider.instance = undefined;
      EditOrganizationDataProvider.instance = previousOrgInstance;
    });
  }

}

export default angular
  .module('main.notifications.groups.edit', [
    EditNotificationGroupDataProviderModule,
    UsersTabModule,
    SettingsTabModule,
  ])
  .config(EditNotificationGroupsRouter)
  .controller('EditNotificationGroupsController', EditNotificationGroupsController)
  .name;
